import jQuery from 'jquery';
import throttle from 'lodash/throttle';

( function( win, doc, $ ) {

    // Update header
    var headerHeight = '',
        $win = $(window);

    const smallBreakPoint = 700,
          $content = $('#content'),
          $siteHeader = $('.site-header');
    

    $win.on('resize', throttle( resizeWindowHander, 250, { 'leading': false } ) );
    
    function resizeWindowHander() {

        if ( $win.width() < smallBreakPoint ) {
          
            let currentHeaderHeight = $siteHeader.height();

            if ( headerHeight != currentHeaderHeight ) {
              
                headerHeight = currentHeaderHeight;

                // Push down #content based on the headers height
                $content.css('padding-top', currentHeaderHeight);

            } 

            // Push down off canvas menu if .off-canvas data-transition="fulloverlay"
            setTimeout( function() {
            
                $('.off-canvas.is-transition-fulloverlap').css( 'top', headerHeight );
                console.log('done');

            }, 1000 );

            return true;

        } 

        else if ( Foundation.MediaQuery.atLeast('medium') ) {
        
            $content.removeAttr('style');
            return false;
        
        }

    }

    resizeWindowHander();

} )( window, document, jQuery );